import { FormControl } from "@angular/forms";
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy } from "@angular/core";
import { GridActionsService } from "../../data-grid/grid-actions.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-column-selector-header-renderer",
  templateUrl: "./column-selector-header-renderer.component.html",
  styleUrls: ["./column-selector-header-renderer.component.scss"],
})
export class ColumnSelectorHeaderRendererComponent implements AfterViewInit,OnDestroy {
  params;
  columnId: number;
  control: FormControl = new FormControl();
  selectedColumnMap;
  private destroy$ = new Subject<void>();
  constructor(
    private gridActionsService: GridActionsService,
    private cdr: ChangeDetectorRef
  ) {
    this.selectedColumnMap = this.gridActionsService.selectedColumnMap;
  }

  agInit(params): void {
    this.params = params;
    this.columnId = +params.displayName;
    this.checkIfSelected();
    this.control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.checkForMatch(value);
      this.checkIfAllSelected();
    });
  }

  checkForMatch(value) {
    const selectOldColumnIndex = this.selectedColumnMap.findIndex(
      (item: any) => {
        return item.columnIndex === this.columnId;
      }
    );
    if (selectOldColumnIndex !== -1) {
      this.selectedColumnMap[selectOldColumnIndex].columnIndex = null;
    }
    if (value) {
      const selectedNewColumnIndex = this.selectedColumnMap.findIndex(
        (item: any) => {
          return item.name.toLowerCase() === value.toLowerCase();
        }
      );
      this.selectedColumnMap[
        selectedNewColumnIndex
      ].columnIndex = this.columnId;
    }
  }

  checkIfAllSelected() {
    const amountSelected = this.gridActionsService.selectedColumnMap.filter(
      (e) => e.columnIndex !== null
    ).length;
    this.gridActionsService.selectedColumnCount = amountSelected;
   this.gridActionsService.selectedColumnCount!=0 ? this.gridActionsService.changedHeader$.next(true) : this.gridActionsService.changedHeader$.next(false)
  }

  checkIfSelected() {
    const currentColumn = this.selectedColumnMap.find(
      (item) => item.columnIndex === this.columnId
    );
    if (currentColumn) {
      this.control.patchValue(currentColumn.name);
    }
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
